import { render, staticRenderFns } from "./CreatePrivilege.vue?vue&type=template&id=2e53dcfe&scoped=true&"
import script from "./CreatePrivilege.vue?vue&type=script&lang=js&"
export * from "./CreatePrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53dcfe",
  null
  
)

export default component.exports